import { useClient } from "@/hooks/useClient";
import { language_change } from "@/utils/gtm";
import Link from "next/link";

import { useRouter } from "next/router";

const LocaleSwitcher = ({ isResponsive = false }) => {
  const { asPath, locale, query, pathname } = useRouter();
  const { isClient } = useClient();

  return (
    <Link
      href={{ pathname, query }}
      as={asPath}
      onClick={() => language_change(locale === "ar" ? "en" : "ar")}
      locale={locale === "ar" ? "en" : "ar"}
    >
      {locale === "en"
        ? "العربية"
        : isResponsive && isClient
        ? "English"
        : "En"}
    </Link>
  );
};

export default LocaleSwitcher;
